import styled from 'styled-components'
import { useState,useEffect } from 'react'
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select  from '@mui/material/Select';
import { useDispatch } from 'react-redux'

const Container=styled.div`
  width:80%;
  margin:10px
 `;

export default function SelectOption(props){
  let { label,estado,action,consolaIndice,data }=props;
  let dispatch=useDispatch();
  const [consola, setConsola] = useState(consolaIndice);
    
  
  const handleChange = (event,newvalue) => { 
    setConsola(newvalue.props.value);  
    dispatch(action( {[label]:newvalue.props.value} ))
   
  };
  useEffect(()=>{
    setConsola(consolaIndice);
  },[consolaIndice]);

  useEffect(()=>{
    if(estado===2){
     dispatch(action( {[label]:consolaIndice} ))}    
  },[estado,label,dispatch,action,consolaIndice]);

  

  
  
  return(
    <Container>      
      <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id={label}>{label}</InputLabel>
        <Select
          size="small"
          id={label}
          value={consola}
          label={label}
          onChange={handleChange}
        >
          {data.map((ele)=>(<MenuItem  key={ ele.value} value={ele.value}>{ele.label}</MenuItem>))}
          
         
         
        </Select>
      </FormControl>
    </Box>
    </Container>
    )
}


